import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { StyleSheet } from 'react-native';

export const Hint = () => {
  const { scale } = useScaling();

  return (
    <Stack align="center" gap={scale(1)}>
      <Text variant="Font Inter/Subtitle/Bold 12px" style={styles.hintText}>
        {'For verification approval, contact '}
      </Text>
      <Text variant="Font Inter/Subtitle/Bold 12px" style={styles.hintEmail}>
        {STRINGS.supportEmail}
      </Text>
    </Stack>
  );
};

const styles = StyleSheet.create({
  hintText: {
    color: colors.Blue,
    textAlign: 'center',
  },
  hintEmail: {
    color: colors['Blue 2'],
    textAlign: 'center',
  },
});
